export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'guide',
    name: '使用指南',
    description: 'http //www.17c/ 完整访问指引与使用教程，帮助您快速上手平台各项功能',
    icon: 'ri-guide-line',
  },
  {
    slug: 'features',
    name: '平台功能',
    description: '探索 17c 平台核心功能模块，了解每一项功能如何提升您的使用体验',
    icon: 'ri-apps-line',
  },
  {
    slug: 'faq',
    name: '常见问题',
    description: '关于 http //www.17c/ 的常见问题解答，覆盖入口访问、注册登录、功能使用等',
    icon: 'ri-question-answer-line',
  },
];

export const categoryMap: Record<string, Category> = {};
categories.forEach((c) => {
  categoryMap[c.slug] = c;
});